import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { billing } from '../../mockData';
import './History.css';

function PaymentHistory() {
  const { Title } = Typography;

  const columns = [
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount', align: 'right', render: (v) => `$${v.toFixed(2)}` },
    { title: 'Method', dataIndex: 'method', key: 'method' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'paid' ? 'green' : 'orange'}>{s.toUpperCase()}</Tag> },
  ];

  return (
    <div className="agency-billing-history">
      <Title level={3}>Payment History</Title>
      <Table rowKey="id" columns={columns} dataSource={billing.history} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default PaymentHistory;
